import { Component, Input, ViewEncapsulation, inject, input } from '@angular/core';
import {ComponenteDigital} from "@cdk/models";
import {LoginService} from "../../../../main/auth/login/login.service";
import { MatBadge } from '@angular/material/badge';

import { SafeResourceUrlPipe } from '../../../../../@cdk/pipes/safe-resource-url.pipe';

@Component({
    selector: 'chat-imagem',
    templateUrl: './chat-imagem.component.html',
    styleUrls: ['./chat-imagem.component.scss'],
    encapsulation: ViewEncapsulation.None,
        imports: [MatBadge, SafeResourceUrlPipe]
})
export class ChatImagemComponent
{
    private _loginService = inject(LoginService);

    readonly mensagensNaoLidas = input<number>(0);
    @Input()
    imagem: ComponenteDigital = null;



    /**
     * @param _loginService
     */
    constructor()
    {
    }

}
